import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
header: {
  background: theme?.palette?.primaryBG?.[700],
  padding: "10px 13% 10px 10%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

  // ✅ 1281 → 1440
  [theme.breakpoints.between(1280, 1440)]: {
    padding: "10px 6% 10px 11.5%"
  },

  // ✅ 1180 → 1280 (NEW RANGE)
  [theme.breakpoints.between(1180, 1280)]: {
    padding: "10px 6.5% 10px 10.5%" // 👈 adjust as needed
  },

  // ✅ 1024 → 1180
  [theme.breakpoints.between(1025, 1180)]: {
    padding: "10px 7.5% 10px 12.5%"
  },

  // ✅ below 1024
  [theme.breakpoints.down(1025)]: {
    padding: "10px 2% 10px 1%"
  },

  [theme.breakpoints.down("md")]: {
    padding: "10px"
  },
  [theme.breakpoints.up(1440)]: {
    padding: "10px 15.3% 10px 11.5%" 
  }
},
  headerLogo: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      marginRight: "5px"
    },
    "& img,svg": {
      width: "124px",
      height: "40px",
      objectFit: "contain",
      [theme.breakpoints.down("md")]: {
        marginRight: "5px",
        width: "40px",
        height: "40px"
      },

      [theme.breakpoints.down("599")]: {
        marginRight: "5px",
        width: "36px",
        height: "36px"
      },
      [theme.breakpoints.down("400")]: {
        marginRight: "5px",
        width: "32px",
        height: "32px"
      }
    }
  },
  accountBtn: {
    "&&": {
      background: theme?.palette?.appHeaderButtonBG?.red,
      color: theme?.palette?.appHeaderText?.main,
      "& .MuiButton-startIcon img": {
        transition: "filter 0.3s ease"
      },
      "&:hover, &:active": {
        background: theme?.palette?.appHeaderButtonBG?.active,
        color: theme?.palette?.appHeaderText?.active,
        "& .MuiButton-startIcon img": {
          filter: "brightness(0)"
        }
      }
    },
    [theme.breakpoints.down("sm")]: {
      "&&": {
        minWidth: "40px",
        width: "40px",
        height: "40px",
        padding: "0",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      "& .MuiButton-startIcon": {
        margin: 0
      }
    }
  },
  headerRight: {
    display: "flex",
    position: "relative",
    zIndex: "1",
    columnGap: "8px",
    "& button": {
      background: theme?.palette?.appHeaderButtonBG?.red,
      color: theme?.palette?.appHeaderText?.main,
      "&:hover": {
        background: theme?.palette?.appHeaderButtonBG?.active,
        color: theme?.palette?.appHeaderText?.active
      }
    }
  },
  btnPrimary: {
    borderRadius: "5px",
    minHeight: "36px",
    padding: "6px 20px",
    fontSize: "14px",
    fontWeight: "600",
    textTransform: "capitalize",

    [theme.breakpoints.down("sm")]: {
      padding: "6px",
      fontSize: "10px",
      borderRadius: "5px"
    },
    "& .MuiButton-startIcon": {
      [theme.breakpoints.down("sm")]: {
        marginRight: "2px"
      },
      "& .MuiSvgIcon-root": {
        [theme.breakpoints.down("sm")]: {
          fontSize: "15px"
        }
      }
    }
  },
  btnPrimaryLang: {
    borderRadius: "5px",
    padding: "6px 20px",
    fontSize: "14px",
    fontWeight: "600",
    textTransform: "capitalize",
    [theme.breakpoints.down("sm")]: {
      // padding: "6px 6px",
      // fontSize:"12px"
      padding: "0 10px",
      minWidth: "auto",
      fontSize: "12px",
      borderRadius: "8px",
      display: "none"
    },
    "& span": {
      [theme.breakpoints.down("sm")]: {
        display: "none"
      }
    }
  },

  balanceBtnWrap: {
    display: "flex",
    "& button": {
      display: "flex",
      minWidth: "90px",
      alignItems: "center",
      justifyContent: "center",
      marginLeft: "0px !important",
      [theme.breakpoints.down("sm")]: {
        padding: "6px",
        fontSize: "11px",
        minWidth: "90px",
        lineHeight: "24px"
      },
      "& span": {
        // marginRight: "15px",
        display: "flex",
        [theme.breakpoints.down("sm")]: {
          // marginRight: "3px",
        },
        "& img,svg": {
          // filter: "invert(1)",
          [theme.breakpoints.down("sm")]: {
            width: "14px",
            position: "relative",
            bottom: "1px"
          }
        }
      }
    }
  },
  subHeader: {
    padding: "0 10px 0",
    background: theme?.palette?.primaryBG?.[300],
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      display: "none"
    }
  },
  headerLink: {
    cursor: "pointer",
    height: "40px",
    fontWeight: "600!important",
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    color: theme?.palette?.primaryText?.[100],
    textTransform: "uppercase",
    padding: "0px 20px",
    fontSize: "14px",
    [theme.breakpoints.down("sm")]: {
      whiteSpace: "nowrap"
    },
    "&:hover": {
      color: theme?.palette?.primary2TextColor?.main
    }
  },
  activeLink: {
    boxShadow: `inset 0 -2px ${theme?.palette?.primary2?.color}`,
    color: `${theme?.palette?.primary2TextColor?.main} !important`
  },
  myAccountLink: {
    textDecoration: "none",
    color: theme?.palette?.primaryText?.[100]
  },
  signupWrap: {
    width: "100%",
    background: `${theme?.palette?.primaryBG?.[600]} !important`,
    borderRadius: "10px",
    padding: "0 !important",
    [theme.breakpoints.down("md")]: {
      width: "100%"
    }
  },
  loginWrap: {
    background: `${theme?.palette?.primaryBG?.[600]} !important`,
    borderRadius: "10px",
    width: "460px",
    [theme.breakpoints.down("md")]: {
      width: "100%"
    },
    "& .MuiSvgIcon-root": {
      color: theme?.palette?.secondaryText?.[700]
    }
  },
  languageMenu: {
    "& ul": {
      background: theme?.palette?.primaryBG?.[500],
      borderRadius: "10px",
      padding: "0",
      width: "100px",
      "& li": {
        borderBottom: "1px solid rgba(255, 255, 255, 0.4)",
        fontSize: "14px",
        display: "flex",
        justifyContent: "center",
        fontWeight: "600",
        "&:hover": {
          color: theme?.palette?.primary2TextColor?.main
        },
        "&:last-child": {
          borderBottom: "none"
        },
        [theme.breakpoints.down("md")]: {
          minHeight: "40px",
          padding: "5px",
          fontSize: "12px"
        }
      },
      [theme.breakpoints.down("md")]: {
        width: "auto",
        minWidth: "auto"
      }
    }
  },
  accountMenu: {
    "& ul": {
      background: theme?.palette?.primaryBG?.[650],
      borderRadius: "10px",
      padding: "0",
      "& li": {
        borderBottom: "1px solid rgb(255 255 255 / 11%)",
        display: "flex",
        alignItems: "center",
        fontSize: "14px",
        fontWeight: "500",
        "& span": {
          marginRight: "15px",
          "& img,svg": {
            width: "18px"
          }
        },
        "&:hover": {
          color: theme?.palette?.primary2TextColor?.main
        },
        "&:last-child": {
          borderBottom: "none"
        }
      }
    }
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    // [theme.breakpoints.down("lg")]: {
    //   paddingLeft: "40px",
    // },
    [theme.breakpoints.down("1024")]: {
      paddingLeft: "20px",
    },
     [theme.breakpoints.down(1025, 1280)]: {
      paddingLeft: "0px",
    },
    [theme.breakpoints.down(1280, 1440)]: {
      paddingLeft: "10px",
    }
  },
  mobToggle: {
    marginRight: "8px",
    display: "none",
    "& img,svg": {
      width: "20px",
      height: "20px",
      transform: "rotate(180deg)"
    },
    [theme.breakpoints.down("md")]: {
      display: "flex"
    }
  },
  mobSidebar: {
    background: theme?.palette?.primaryBG?.[500],
    width: "280px",
    height: "100vh",
    position: "fixed",
    left: "-310px",
    transform: "translateX(-310px)",
    top: "50px",
    zIndex: "1",
    paddingTop: "10px",
    display: "none",
    transition: "all 400ms  ease-in-out",
    "& a": {
      display: "block",
      padding: "15px 20px",
      textDecoration: "none",
      color: theme?.palette?.primaryText?.[100],
      borderBottom: `1px solid ${theme?.palette?.primaryText?.[200]}`,
      cursor: "pointer",
      fontSize: "14px",

      "&:hover": {
        color: theme?.palette?.primary2TextColor?.main
      }
    },
    [theme.breakpoints.down("md")]: {
      display: "block"
    }
  },
  mobSidebarActive: {
    background: theme?.palette?.primaryBG?.[500],
    width: "280px",
    height: "100vh",
    position: "fixed",
    top: "50px",
    left: "0",
    zIndex: "9",
    paddingTop: "10px",
    display: "none",
    transition: "all 400ms  ease-in-out",
    "& a": {
      display: "block",
      padding: "8px 20px",
      textDecoration: "none",
      color: theme?.palette?.primaryText?.[100],
      borderBottom: `1px solid ${theme?.palette?.primaryText?.[200]}`,
      cursor: "pointer",
      fontSize: "14px",

      "&:hover": {
        color: theme?.palette?.primary2TextColor?.main
      }
    },
    [theme.breakpoints.down("md")]: {
      display: "block"
    }
  },
  sidebarClose: {
    cursor: "pointer",
    position: "absolute",
    right: "-29px",
    top: "0",
    background: theme?.palette?.primaryBG?.[500],
    padding: "8px",
    display: "flex",
    borderRadius: "0",
    "& img,svg": {
      width: "14px"
    }
  },
  countryFlagImg: {
    marginRight: "5px",
    width: "20px",
    height: "20px"
  },
  mobileLanDropdown: {
    background: "transparent",
    fontSize: "14px"
  },
  mr12: {
    marginRight: "12px"
  },
  mobileLanButton: {
    color: theme?.palette?.primaryText?.[100],
    fontSize: "14px",
    fontWeight: "600",
    textTransform: "capitalize"
  },
  mobLanOption: {
    background: theme?.palette?.primaryBG?.[350]
  },
  sidebarContent: {
    height: "100vh"
  },
  coinWraper: {
    display: "flex",
    height: "22px",
    marginRight: "4px",
    position: "relative",
    bottom: "1px",
    [theme.breakpoints.down("sm")]: {
      padding: "6px 0px 6px 6px",
      fontSize: "11px"
    },
    "& img,svg": {
      [theme.breakpoints.down("sm")]: {
        width: "16px",
        height: "16px",
        position: "relative",
        bottom: "3px"
      }
    }
  },
  formGroup: {
    position: "relative",
    marginBottom: "20px",
    "& .MuiFormControl-root": {
      width: "100%"
    }
  },
  agentContent: {
    textAlign: "center",
    margin: "20px 0",
    "& .MuiTypography-h5": {
      fontWeight: "bold",
      textTransform: "uppercase"
    }
  },
  agentFormWrap: {
    padding: "20px 40px",
    "& .MuiInputBase-input": {
      height: "20px",
      padding: "10px",
      "&:hover": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: theme?.palette?.primary2TextColor?.main
        }
      }
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "10px",
      borderColor: "rgb(143, 102, 171)"
    },
    "& .MuiFormLabel-root": {
      top: "-5px",
      fontSize: "12px",
      color: "rgba(255, 255, 255, 0.3)"
    },
    "& .Mui-disabled": {
      color: theme?.palette?.primaryText?.[100],
      fontWeight: "600"
    }
  },
  agentLoader: {
    color: theme?.palette?.primary2TextColor?.main
  },
  agentFields: {
    "& .Mui-disabled": {
      cursor: "pointer"
    }
  },
  toolTipWrap: {
    fontSize: "10px",
    fontWeight: "600",
    background: theme?.palette?.secondaryBG?.main,
    color: theme?.palette?.secondaryText?.[700]
  },
  toolTipArrow: {
    background: theme?.palette?.secondaryBG?.main
  },
  headerWrap: {
    position: "fixed",
    width: "100%",
    top: "0",
    zIndex: "1000"
  },

  gameCloseBtn: {
    width: "20px",
    justifyContent: "flex-end",
    "&.MuiButton-root": {
      "&:hover": {
        backgroundColor: "unset"
      }
    },
    "& img,svg": {
      width: "15px"
    }
  },
  iconStyle: {
    fontSize: "19px",
    height: "18px",
    width: "20px",
    display: "flex",
    fontWeight: "600",
    alignItems: "center",
    paddingTop: "4px",
    justifyContent: "center",
    cursor: "pointer",
    transition:
      "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    background: theme?.palette?.secondaryBG?.main,
    borderRadius: "0 0 0 5px",
    color: theme?.palette?.secondaryText?.[700],
    "&:hover": {
      background: theme?.palette?.primaryBG?.[450],
      color: theme?.palette?.primaryText?.[100]
    }
  },
  iconWrap: {
    display: "flex",
    flexDirection: "column",
    alignItems: "Center"
    // borderRight: "2px solid black"
    // paddingRight: "10px"
  },
  userBalance: {
    minHeight: "36px !important",
    padding: "6px 10px 6px 8px  !important",
    fontSize: "14px !important",
    fontWeight: "600 !important",
    textTransform: "capitalize !important"
  },
  botagentUserBalance: {
    minHeight: "36px !important",
    padding: "6px 10px 6px 2px  !important",
    color: `${theme?.palette?.secondaryText?.[700]} !important`,
    fontSize: "14px !important",
    fontWeight: "600 !important",
    textTransform: "capitalize !important",
    "&:hover": {
      "& .iconWrap": {
        color: theme?.palette?.primaryText?.[100]
      }
    }
  },
  iconPlusStyle: {
    // borderBottom: "2px solid #000",
    borderRadius: "5px 0 0 0"
  },
  balanceBoatBtn: {
    "& button": {
      borderRadius: "0 5px 5px 0"
    }
  },
  plusMinusIcon: {
    fontSize: "15px",
    fontWeight: "700"
  },
  btnbetLimit: {
    borderRadius: "35px !important",
    padding: "8px !important",
    minWidth: "33px",
    maxWidth: "35px",
    height: "35px"
  },
  betLimitMenu: {
    "& ul": {
      background: theme?.palette?.primaryBG?.[500],
      borderRadius: "10px",
      padding: "16px 0px",
      height: "auto",
      maxHeight: "300px",
      overflowY: "auto",
      "& .MuiMenuItem-root": {
        [theme.breakpoints.down("sm")]: {
          padding: "0px",
          minHeight: "32px"
        }
      },
      "& li": {
        borderBottom: "1px solid transparent !important",
        display: "flex",
        alignItems: "center",
        fontSize: "14px",
        fontWeight: "500",
        fontFamily: "Poppins",
        "& span": {
          marginLeft: "15px",
          "& img,svg": {
            width: "18px"
          }
        },

        "&:last-child": {
          borderBottom: "none"
        }
      }
    }
  },
  translationWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%"
  },
  betTranslation: {
    marginLeft: "5px"
  },
  betLimitExceed: {
    display: "flex",
    fontSize: "14px",
    fontFamily: "Poppins",
    fontWeight: "500",
    fontStyle: "italic",
    justifyContent: "center",
    alignItems: "center"
  },
  maxBetLimit: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "16px",
    fontWeight: "500"
  },
  menuHeaderWrap: {
    display: "flex",
    padding: "16px 12px",
    justifyContent: "center",
    width: "100%",
    "& .MuiTypography-root": {
      color: theme?.palette?.primaryText?.[100],
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "21px",
      fontFamily: "poppins",
      textWrap: "nowrap",
      overflow: "hidden",
      width: "50%",
      textOverflow: "ellipsis",
      textAlign: "left"
    },
    "& span": {
      color: theme?.palette?.secondaryBG?.main,
      fontFamily: "poppins",
      fontWeight: "600",
      lineHeight: "21px",
      fontSize: "14px",
      textWrap: "wrap",
      maxWidth: "calc(100% - 16px)",
      width: "calc(100% - 16px)",
      minWidth: "calc(100% - 16px)",
      display: "inline-block",
      textOverflow: "ellipsis",
      overflow: "hidden",
      overflowWrap: "anywhere"
    }
  },
  walletWrapper: {
    width: "50%",
    display: "flex",
    gap: "5px"
  },
  redirectBtnWrapper: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    padding: "0px 12px",
    "& .MuiButtonBase-root": {
      borderRadius: "6px",
      fontFamily: "poppins",
      fontSize: "14px",
      lineHeight: "21px",
      fontWeight: "700",
      textTransform: "capitalize",
      width: "50%"
    }
  },
  depositeButton: {
    backgroundColor: theme?.palette?.secondaryBG?.main,
    color: theme?.palette?.primaryBG?.[500],
    marginLeft: "5px",
    "&:hover": {
      backgroundColor: theme?.palette?.secondaryBG?.main,
      color: theme?.palette?.primaryBG?.[500]
    }
  },
  withDrawButton: {
    color: theme?.palette?.primaryText?.[100],
    background: theme?.palette?.primaryBG?.[400],
    marginRight: "5px"
  }
}));
